import { useEffect, useState } from "react";
import { useT } from "../i18n/I18nProvider";

export default function CookieBanner() {
  const { t } = useT();
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("hejpoland_cookies")) setShow(true);
  }, []);
  const accept = (val) => { localStorage.setItem("hejpoland_cookies", val); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md bg-white border border-slate-200 rounded-2xl shadow-2xl p-5 z-50" data-testid="cookie-banner">
      <h4 className="font-display font-semibold text-slate-900 mb-1.5">{t("cookies.title")}</h4>
      <p className="text-sm text-slate-600 leading-relaxed mb-4">{t("cookies.body")}</p>
      <div className="flex gap-2">
        <button onClick={() => accept("accepted")} className="flex-1 bg-[#0056D2] hover:bg-[#0047AD] text-white text-sm font-medium px-4 py-2 rounded-full transition" data-testid="cookie-accept">
          {t("cookies.accept")}
        </button>
        <button onClick={() => accept("rejected")} className="flex-1 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 text-sm font-medium px-4 py-2 rounded-full transition" data-testid="cookie-reject">
          {t("cookies.reject")}
        </button>
      </div>
    </div>
  );
}
